import { COMPANY, NAV_LINKS, waLink } from "@/lib/site";
import { MessageCircle, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-animax-black text-white pt-20 pb-8 relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-animax-yellow/40 to-transparent" />

      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-12 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4">
              <img
                src={COMPANY.logos.animaxBadge}
                alt="ANIMAX"
                className="h-14 w-14 object-contain rounded-md"
              />
              <img
                src={COMPANY.logos.animaxFull}
                alt="ANIMAX Acrylic Sheet"
                className="h-14 w-auto object-contain bg-white rounded-md p-1"
              />
            </div>
            <p className="mt-6 font-display text-xl text-white leading-snug max-w-md">
              {COMPANY.name}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="tag-uppercase text-white/60 mb-4">Navigasi</div>
            <ul className="space-y-2">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.href.replace(/[\/#]/g, "")}`}
                    className="text-sm text-white/80 hover:text-animax-yellow transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="tag-uppercase text-white/60 mb-4">Kontak</div>
            <div className="space-y-3">
              {COMPANY.whatsapp.map((w, i) => (
                <a
                  key={i}
                  href={waLink(w.raw, "Halo, saya ingin bertanya tentang ANIMAX Acrylic")}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-wa-${i}`}
                  className="flex items-center gap-2 text-sm text-white/80 hover:text-animax-yellow"
                >
                  <MessageCircle className="w-4 h-4" />
                  {w.number} <span className="text-white/40">· {w.name}</span>
                </a>
              ))}
              <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="flex items-center gap-2 text-sm text-white/80 hover:text-animax-yellow break-all">
                <Mail className="w-4 h-4 shrink-0" />
                {COMPANY.email}
              </a>
              <div className="flex items-start gap-2 text-sm text-white/80">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                <span>{COMPANY.address}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/50">
            © {new Date().getFullYear()} PT. Animax Putra Lancar. Seluruh hak cipta dilindungi.
          </p>
          <p className="text-xs text-white/50">
            Trading & Distributor ANIMAX Acrylic Sheet (PMMA) · Mojokerto, Jawa Timur, Indonesia
          </p>
        </div>
      </div>
    </footer>
  );
};
